import React, {useState} from "react";
import {updatePassword} from "../api";
import {Alert, Button, Form, Input, message} from "antd";
import {t} from "../locales/locales";

function UpdatePasswordModal(onClose: () => void) {
    const [orgPassword, setOrgPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const handleSubmit = async () => {
        setError("");
        setSuccess("");

        if (newPassword !== confirmPassword) {
            setError(t("navbar_password_mismatch"));
            return;
        }

        try {
            await updatePassword(orgPassword, newPassword);
            message.success(t("navbar_password_update_success_notify"));
            setOrgPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setSuccess(t("navbar_password_update_success_message"))
            onClose();
        } catch (err: any) {
            console.error(err);
            setError(t("navbar_password_update_failed"));
        }
    };

    return (
        <Form layout="vertical" onFinish={handleSubmit}>
            {error && (
                <Alert
                    type="error"
                    message={error}
                    style={{marginBottom: 16}}
                    showIcon
                />
            )}
            {success && (
                <Alert
                    type="success"
                    message={success}
                    style={{marginBottom: 16}}
                    showIcon
                />
            )}

            <Form.Item label={t("navbar_original_password")} required>
                <Input.Password
                    value={orgPassword}
                    onChange={(e) => setOrgPassword(e.target.value)}
                />
            </Form.Item>

            <Form.Item label={t("navbar_new_password")} required>
                <Input.Password
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
            </Form.Item>

            <Form.Item label={t("navbar_confirm_new_password")} required>
                <Input.Password
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
            </Form.Item>

            <Form.Item style={{textAlign: "right"}}>
                <Button type="primary" htmlType="submit">
                    {t("navbar_change_password_button")}
                </Button>
            </Form.Item>
        </Form>
    );
}

export default UpdatePasswordModal;
